/**
 * Csv Schema of Alerta
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Alerta} from '@/model/resource/Alerta'

/* TODO: review generated schema */
export class CsvAlertaSchema extends Schema {
  readonly name = 'CsvAlerta'

  readonly fieldSet: FieldSet<Alerta> = {
    idAlertaPk: schema => schema.model.idAlertaPk,
    descricao: schema => schema.model.descricao,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
